<template>
    <div class="common_container">
        <el-form :rules="rules" :model="messageForm" ref="messageForm" label-width="100px">
            <el-form-item label="所属上级" prop="company">
                <el-cascader ref="getDefaultValue" v-model="messageForm.company" :props="propsData" class="form-input"></el-cascader>
                <!-- <el-cascader
                    v-model="company"
                    :options="companyOptions"
                    @change="companyChange"></el-cascader> -->
            </el-form-item>
            <el-form-item label="分类名称" prop="title">
                <el-input v-model="messageForm.title" class="form-input"></el-input>
            </el-form-item>
            <el-form-item label="分类编码" prop="code">
                <el-input v-model="messageForm.code" class="form-input"></el-input>
            </el-form-item>
            <el-form-item label="备注" prop="desc">
                <el-input type="textarea" v-model="messageForm.comment" class="form-input"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" size="small" @click="submit">确认</el-button>
                <el-button type="primary" size="small" @click="restart">重置</el-button>
                <el-button type="default" size="small" @click="onCancel">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import services from "../event.service";
    import { getRules } from "../classify.rules";
    const rules = getRules();
    let id = 0;
    export default {
        props:{
            type:{//类型  默认 add =>新增    edit => 修改
                type:String,
                default:"add"
            },
            name:{//修改的信息
                type:Object,
            },
            callback: {//回掉处理
                type: Function
            }
        },
        data() {
            return {
                formName:"messageForm",
                rules:rules,
                // company: ['0'],//选择上级
                messageForm: {//表单信息
                    type: '15',
                    title: '',
                    code: '',
                    comment: '',
                    company:['0']
                },
                propsData: {
                    lazy: true,
                    checkStrictly: true,
                    lazyLoad (node, resolve) {
                        const { level } = node;
                        if(level<1){
                            services.getSortListMes({"type":"15"}).then(res => {
                                let nodes = [];
                                res.forEach(item=>{
                                    nodes.push({value: item.id,label: item.title,leaf:!item.hasChildren})
                                })
                                // 通过调用resolve将子节点数据返回，通知组件数据加载完成
                                resolve(nodes);
                            }).catch(err => {
                                this.$message.error(err.message);
                            }).finally(() => {
                                this.loading = false;
                            })
                        }else{
                            services.getChildSortListMes({"parentId":node.data.value}).then(res => {
                                let nodes = [];
                                res.forEach(item=>{
                                    nodes.push({value: item.id,label: item.title,leaf:!item.hasChildren})
                                })
                                // 通过调用resolve将子节点数据返回，通知组件数据加载完成
                                resolve(nodes);
                            }).catch(err => {
                                this.$message.error(err.message);
                            }).finally(() => {
                                this.loading = false;
                            })
                        }
                    }
                }
            }
        },
        mounted() {
            if(this.type == 'edit'){//返显需要修改的信息
                this.$modal.title = "修改";
                services.getDetailMes({id:this.name.id}).then(res=>{
                    this.messageForm = res;
                    this.messageForm.company = [res.parentId];
                    if(res.parentId){
                        this.$refs.getDefaultValue._data.inputValue = res.parentTitle;
                    }else{
                        this.$refs.getDefaultValue._data.inputValue = '知识分类';
                    }

                })
            }else{
                this.$refs.getDefaultValue._data.inputValue = '知识分类';
            }
        },
        methods: {
            companyChange(value) {//选择上级
                this.messageForm.level = value[0];
                // this.messageForm.name = value[1];
            },
            submit(){//提交信息
                this.messageForm.parentId = this.messageForm.company[this.messageForm.company.length-1];
                let formName = this.formName;
                this.$refs[formName].validate((valid) => {
                    if(valid){
                        if(this.type == 'edit'){
                            services.changeMes(this.messageForm).then(res => {
                                this.$message.success("事件修改成功");
                                this.close(true);
                            }).catch(err => {
                                this.$message.error(err.message);
                            })
                        }else{
                            services.addMes(this.messageForm).then(res => {
                                this.$message.success("事件添加成功");
                                this.close(true);
                            }).catch(err => {
                                this.$message.error(err.message);
                            })
                        }
                    };
                    return valid;
                })

            },
            restart(){//重置信息
                // this.company = ['0'];
                this.messageForm= {
                    ...this.messageForm,
                    code:'',
                    title:'',
                    comment:''
                }
            },
            onCancel(){//关闭该弹框
                this.close();
            },
            close(refresh) {//关闭该弹框   refresh => true 刷新列表
                this.$modal.close();
                refresh && refresh === true ? this.callback() : '';
            }
        }
    }
</script>

<style scoped>
    .inputWidth{
        width: 300px;
    }
</style>
